import type { ReactNode } from 'react'
import { Box } from '@mui/material'

import Button from '@base/Button/Button.component'

interface Props {
  /**
   * Drives the Kratos `method` discriminator via the submit button's
   * name/value pair. Omit both when the discriminator is carried by a hidden
   * input instead — required for forms that may be submitted programmatically
   * (`form.requestSubmit()` with no submitter omits the button's name/value).
   */
  submitName?: string
  submitValue?: string
  submitLabel: string
  /** Trailing icon inside the submit button (e.g. an arrow). */
  submitEndIcon?: ReactNode
  /**
   * For fetch-driven submits, where the page stays put and the button would
   * otherwise stay clickable for the whole round-trip. Native form POSTs
   * navigate away and do not need it.
   */
  submitDisabled?: boolean
}

// Full-width primary submit. `submitName`/`submitValue` drive the Kratos
// `method` discriminator and are passed through verbatim. Back-navigation is a
// top-of-card BackButton, not a secondary link here.
const SubmitRow = ({
  submitName,
  submitValue,
  submitLabel,
  submitEndIcon,
  submitDisabled,
}: Props) => (
  <Box data-testid='submit-row' sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
    <Button
      variant='primary'
      size='lg'
      block={true}
      type='submit'
      name={submitName}
      value={submitValue}
      disabled={submitDisabled}
    >
      {submitLabel}
      {submitEndIcon}
    </Button>
  </Box>
)

export default SubmitRow
